import { render, staticRenderFns } from "./EditHistoryCommentModal.vue?vue&type=template&id=e46a7e98&scoped=true&"
import script from "./EditHistoryCommentModal.vue?vue&type=script&lang=ts&"
export * from "./EditHistoryCommentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46a7e98",
  null
  
)

export default component.exports